import { useState, useRef, useEffect } from "react";
import LogoImage from "assets/login_assets/login_logo.png";
import BubbleImage from "assets/login_assets/login_bubble.png";
import Styles from "css/login_css/login_d.module.css";
import GoogleIcon from "assets/login_assets/google_icon.svg";
import KakaoIcon from "assets/login_assets/kakao_icon.svg";
import NaverIcon from "assets/login_assets/naver_icon.svg";
import AppleIcon from "assets/login_assets/apple_icon.svg";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { login } from "firebase_/firebase_function/firebase_user";
import { useUser } from "util/context/user_context";
import OnlyConfirmDialog from "components/onlyConfirm_dialog";
import Footer from "components/footer/footer";
import { emptyCheck } from "util/function/function";
import MobileFooter from "components/footer/footer_m";
import { baseUrl } from "api/baseUrl";

function LoginScreen({ isMobile }) {
  const [modalMessage, setModalMessage] = useState("");
  const [onlyConfirmModal, setOnlyConfirmModal] = useState(false);
  const navigate = useNavigate();
  const { userData, setUserData } = useUser();
  let kakaoInitBool = false; // 카카오 중복 로그인 방지

  useEffect(() => {
    loginCheck();
  }, []);

  // 로그인 체크
  const loginCheck = async () => {
    if (Object.keys(userData).length > 0) {
      navigate(userData.userType === "수리기사" ? "/expertmain" : "/main");
      // console.log("userData : ", userData);
    }
  };

  const handleGoogleLogin = async () => {
    const clientId =
      "872903668661-kbpp517m9a10rf6lhbg36m96hthjc2j5.apps.googleusercontent.com";
    const redirectUri =
      "https://www.ddukddaki.com/api/get/auth/google/callback";
    const scope = "email profile";
    const responseType = "code";
    const accessType = "offline"; // 추가
    const prompt = "select_account"; // 항상 계정 선택
    const includeGrantedScopes = "true"; // 선택적으로 허용된 권한 포함

    const googleAuthUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${encodeURIComponent(
      redirectUri
    )}&response_type=${responseType}&scope=${encodeURIComponent(
      scope
    )}&access_type=${accessType}&include_granted_scopes=${includeGrantedScopes}&prompt=${prompt}`;

    window.location.href = googleAuthUrl;
  };

  /// 카카오 로그인
  const handleKakaoLogin = () => {
    try {
      if (!kakaoInitBool) {
        kakaoInitBool = true;
        window.Kakao.init("3337b529b565bf9ebab35ee187c21fa8");
      }
      window.Kakao.Auth.login({
        success: function (authObj) {
          // console.log(authObj);
          window.Kakao.API.request({
            url: "/v2/user/me",
            success: function (res) {
              const handleKakaoUser = async () => {
                try {
                  const uid = res.id.toString();
                  const getUserData = await login(uid);
                  if (getUserData.length === 0) {
                    setUserData({});
                    sessionStorage.removeItem("userData");
                    navigate("/register", { state: { userId: uid } });
                    return;
                  }
                  const user = getUserData[0];
                  if (user.deleteDate) {
                    setOnlyConfirmModal(true);
                    setModalMessage("탈퇴한 계정입니다.");
                    setUserData({});
                    sessionStorage.removeItem("userData");
                    return;
                  }
                  await setUserData(user);
                  sessionStorage.setItem("userData", JSON.stringify(user.id));
                  navigate(
                    user.userType === "수리기사" ? "/expertmain" : "/main"
                  );
                } catch (error) {
                  console.error("Kakao User Info Fetch Error:", error);
                }
              };
              handleKakaoUser();
            },
          });
        },
        fail: function (err) {
          console.error("kakao login Error : ", err);
        },
      });
    } catch (error) {
      console.error("kakao Error", error);
    }
  };

  /// 네이버 로그인
  const handleNaverLogin = async () => {
    try {
      const naverLogin = await new window.naver.LoginWithNaverId({
        clientId: "azRwAjyCn6cydpIfCHOL",
        callbackUrl: `https://www.ddukddaki.com/loading`,
        loginButton: { color: "green", type: 3, height: 45 },
      });
      naverLogin.init();
      const loginButton = document.getElementById("naverIdLogin_loginButton");
      if (loginButton) {
        loginButton.click();
        return;
      }
    } catch (error) {
      console.error("naver login Error : ", error);
    }
  };

  /// 애플 로그인
  const handleAppleLogin = async () => {
    try {
      const clientId = "farming.farm.com";
      const redirectUri = encodeURIComponent(
        "https://www.ddukddaki.com/api/post/auth/apple/callback"
      );
      const url = `https://appleid.apple.com/auth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=name%20email&response_mode=form_post`;
      window.location.href = url;
    } catch (error) {
      console.error("apple login Error : ", error);
    }
  };

  return (
    <>
      <div
        style={{
          position: "relative",
          display: "flex",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
          background: "linear-gradient(90deg, #ECFDF5 0%, #FFFFFF 100%)",
        }}
      >
        <img
          src={BubbleImage}
          alt="Bubble"
          style={{ position: "absolute", top: "0px", left: "0px" }}
        />
        <div
          style={{
            textAlign: "center",
            margin: "0 46px",
            boxSizing: "border-box",
          }}
        >
          <div className={Styles.f24w700black}>
            뚝딱 로그인하고, 농기계 수리 요청도
          </div>
          <div className={Styles.f24w700black}>빠르게 해결하세요!</div>
          <div style={{ height: "40px" }} />

          <div className={Styles.f20w600black}>
            SNS 계정으로 간편하게 로그인하고, 전문가
          </div>
          <div className={Styles.f20w600black}>
            에게 농기계 수리를 요청해보세요
          </div>
          <div style={{ height: "40px" }} />

          <div className={Styles.googleBox} onClick={handleGoogleLogin}>
            <img src={GoogleIcon} />
            <div className={Styles.f16w500black}>구글 로그인</div>
          </div>
          <div style={{ height: "16px" }} />

          <div className={Styles.kakaoBox} onClick={handleKakaoLogin}>
            <img src={KakaoIcon} />
            <div className={Styles.f16w500black}>카카오 로그인</div>
          </div>
          <div style={{ height: "16px" }} />

          <div>
            <div id="naverIdLogin" style={{ display: "none" }} />
            <div className={Styles.naverBox} onClick={handleNaverLogin}>
              <img src={NaverIcon} />
              <div className={Styles.f16w500white}>네이버 로그인</div>
            </div>
          </div>

          <div style={{ height: "16px" }} />

          <div className={Styles.appleBox} onClick={handleAppleLogin}>
            <img src={AppleIcon} />
            <div className={Styles.f16w500white}>애플 로그인</div>
          </div>
          <div style={{ height: "16px" }} />

          <div style={{ display: "flex", justifyContent: "center" }}>
            <Link
              to={"/terms"}
              className={Styles.f14w400green}
              style={{ cursor: "pointer" }}
              target="_blank"
            >
              이용약관
            </Link>
            <div style={{ width: "4px" }} />
            <div className={Styles.f14w400green}>•</div>
            <div style={{ width: "4px" }} />
            <Link
              className={Styles.f14w400green}
              style={{ cursor: "pointer" }}
              to={"/policy"}
              target="_blank"
            >
              개인정보처리방침
            </Link>
          </div>
        </div>

        {!isMobile && (
          <div>
            <img src={LogoImage} />
          </div>
        )}
        <OnlyConfirmDialog
          open={onlyConfirmModal}
          onClose={() => setOnlyConfirmModal(false)}
          message={modalMessage}
        />
      </div>
      {isMobile ? <MobileFooter /> : <Footer />}
    </>
  );
}

export default LoginScreen;
